import styled from "@emotion/styled"

import { Box, Flex } from "@chakra-ui/react"

export const TabsContainer = styled(Box)`
  width: ${( props ) => (props.width ? `${props.width}px` : "100%")};
  height: ${( props ) => (props.height ? `${props.height}px` : "100%")};
  background: var(--chakra-colors-input_border_color_primary);
  border-radius: 100px;
  font-size: var(--chakra-fontSizes-m);
  color: var(--chakra-colors-button_grey_bg);
`

export const TabItem = styled(Flex)`
  background: transparent;
  border-radius: 100px;
  cursor: pointer;
  transition: .3s ease;

  &.active {
    background: var(--chakra-colors-primary);
    color: var(--chakra-colors-white);
  }
`